const signalR = require("@microsoft/signalr");
import { vueObj } from "../../main";
import Cookies from "@/utils/cookie";
export default {
  conn: {},
  onConnected: null,
  onReconnected: null,
  //初始化连接
  initHub: function () {
    this.conn = new signalR.HubConnectionBuilder()
      .withUrl(
        `${configs.serveBaseURL.replace(/(.*)\/api/, "$1/hubs")}/MPCase`,
        {
          accessTokenFactory: () => Cookies.getToken(),
        }
      )
      .withAutomaticReconnect([1000, 2000, 3000, 4000, 5000, 6000])
      .configureLogging(signalR.LogLevel.Error)
      .build();

    //收到全局提示
    this.conn.on("GCMsgRecv", (success, message) => {
      if (success) {
        vueObj.$toast.success(message);
      } else {
        vueObj.$toast.error(message);
      }
    });

    // 生命周期
    this.conn.onreconnecting((error) => {
      //vueObj.$toast.info("正在尝试重新连接服务器...");
    });

    this.conn.onreconnected((connectionId) => {
      //vueObj.$toast.success("重新连接服务器成功");

      if (this.onReconnected) {
        this.onReconnected();
      }
    });

    //this.conn.onclose(error => {
    //});

    //开始连接
    this.conn.start().then(() => {
      if (this.onConnected) {
        this.onConnected();
      }
    });
  },
};
